@if (dialogData.title) {
  <h1 mat-dialog-title>{{ dialogData.title }}</h1>
}
<div mat-dialog-content>
  <ng-content select=".dialog-content"></ng-content>
</div>
<div mat-dialog-actions>
  <ng-content select=".dialog-actions"></ng-content>
</div>

